import 'bootstrap/dist/css/bootstrap.min.css';
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import { Link } from "react-router-dom";
import bgImage from '../TestImages/StockCake-Nature_Office_Setup-3414517-standard.jpg';
// import appStoreDownloadImg from '../iOSAppStoreDownloadWhite.svg';
import "./LandingPageNew.css";

const appStoreURL = "https://apps.apple.com/us/app/stedi/id6463821285";

function LandingPageNew() {
  return (
    <div className="landing-wrapper d-flex flex-column min-vh-100 pt-4">
       <div
        className="landing-bg"
        style={{ backgroundImage: `url(${bgImage})` }}
      />
      <div className="landing-overlay" />
      <Container className="">
        <div className="landing-header">
          <h4>BEST IN</h4>
          <h4>PRODUCTIVITY</h4>

          <hr className="w-100 my-4 border-2 opacity-100" />

          <h5 className=""> get organized. stay Stedi.</h5>
        </div>
      </Container>

      <Container className="landing-footer">
           <h1 className="landing-brand"> STEDI </h1>
          <Button variant="link" className="download-link">
            <div>
              <a href={appStoreURL}> DOWNLOAD THE APP &rsaquo; </a>
            </div>
          </Button>
{/* 
          <Button variant="link" className="download-link" as={Link} to="/login">
            <div>
              <a href={appStoreURL}> Login &rsaquo; </a>
            </div>
          </Button> */}
          
      </Container>

    </div>
  );
}

export default LandingPageNew;